/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */
import Component from 'can/component/component';

import template from './live-video-player.stache';
import _ from 'lodash';
import can from 'can';
import appContext from 'scripts/app-context';
import dtm from 'scripts/services/dtm';
import deviceUtil from 'scripts/utils/device';

const brightcoveOptions = _.get(window.globalSettings, 'brightcove', {});

Component.extend({
    tag: 'live-video-player',
    template,
    viewModel: {
        analyticsInterval: null,
        streams: [],
    },
    events: {
        inserted() {
            appContext.model.bind('live-channel-selected', (event, streams) => {
                this.viewModel.attr('streams', streams);
                this.pip.updateStream(streams);
                this.updateActiveChannel();
            });

            appContext.model.bind(
                'live-channel-streams-loaded',
                (event, streams, autoPlay, initLoad) => {
                    this.viewModel.attr('streams', streams);
                    if (initLoad) {
                        this.initPlayer(streams);
                    } else {
                        this.pip.updateStream(streams);
                    }
                    this.updateActiveChannel();
                },
            );

            appContext.model.bind(
                'live-video-player-play',
                this.initAnalytics.bind(this),
            );
            appContext.model.bind('live-channel-selected', () =>
                this.hideErrors(),
            );
        },

        updateActiveChannel() {
            appContext.model.dispatch('live-video-player-play', [
                this.viewModel.attr('streams.0.id'),
            ]);
        },

        initPlayer(streams) {
            let settings = new can.Map({
                _debug: false,
                containerId: 'playerHolder',
                dataAccount: brightcoveOptions.accountId,
                dataPlayer: 'rkeYhn82l',
                streams: streams,
                autoPlay: true,
                preRollOnlyPlayerId: brightcoveOptions.live
                    ? brightcoveOptions.live.preRollOnlyPlayerId
                    : 'B12rSV1fW',
                pipSizeUnit: 'PIXEL',
                pipWidth: 225,
                pipInitPositionX: 10,
                pipInitPositionY: 10,
                pipInitCollapsed: true,
                pipBgColor: [51, 54, 63],
                pipOpacityExpand: 0.7,
                pipOpacityActif: 0.7,
                pipOpacityInactif: 0,
                playerTimeSync: false,
                playerTimeSyncLapseCheck: 2,
                playerTimeSyncMaxDelta: 5,
                pipSelectorLabel: 'GROUP',
            });
            $.getScript(brightcoveOptions.pipPath)
                .done(() => {
                    this.pip = usgaPip(settings);

                    dtm.trackPipInteraction();

                    document
                        .getElementById('playerHolder')
                        .addEventListener('pipSwap', (arg) => {
                            if (arg && arg.detail && arg.detail.mainVideo) {
                                appContext.model.dispatch(
                                    'live-video-player-play',
                                    [arg.detail.mainVideo],
                                );
                            }
                            dtm.trackPipChannelSwap();
                        });

                    document
                        .getElementById('playerHolder')
                        .addEventListener('fullscreen', () => {
                            dtm.trackPipGoFullScreen();
                        });

                    //
                    // reserved for future use
                    //
                    // document.getElementById('playerHolder').addEventListener('pipChannelSelect', () => {
                    // implementation
                    // });
                    //

                    document
                        .getElementById('playerHolder')
                        .addEventListener('player1Ready', (arg) => {
                            if (arg && arg.detail && arg.detail.player) {
                                this.configureErrorHandler(arg.detail.player);
                            }
                        });

                    document
                        .getElementById('playerHolder')
                        .addEventListener('player2Ready', (arg) => {
                            if (arg && arg.detail && arg.detail.player) {
                                this.configureErrorHandler(arg.detail.player);
                            }
                        });
                })
                .fail(function(jqxhr, settings, exception) {
                    console.log('Error getting pip script ', exception);
                });
        },

        configureErrorHandler(player) {
            if (deviceUtil.isIE()) {
                player.errors({
                    errors: {
                        '4': {
                            headline:
                                'Adobe Flash Player is required to view this content in Internet Explorer',
                            message:
                                'Please download the latest version of Adobe Flash or use a different browser.',
                        },
                    },
                });
            }
        },

        initAnalytics() {
            if (this.analyticsInterval) {
                clearInterval(this.analyticsInterval);
                this.analyticsInterval = null;
            }
            const analyticsInterval = setInterval(() => {
                const mainPlayer = this.getMainVideoPlayer();

                if (mainPlayer) {
                    const holder = can.$(
                        `[data-video-id]:has(#${mainPlayer.prop('id')})`,
                        this.element,
                    );

                    if (holder.length > 0) {
                        const videoId = holder.attr('data-video-id');
                        if (videoId == this.viewModel.attr('streams.0.id')) {
                            clearInterval(analyticsInterval);
                        }
                    }
                }
            }, 200);
            this.analyticsInterval = analyticsInterval;
        },

        hideErrors() {
            this.element
                .find('.vjs-error-display:not(.vjs-hidden)')
                .addClass('vjs-hidden');
        },

        /*
         * Sometimes pip and main players is changing their ids.
         * This method returns correct main player.
         */
        getMainVideoPlayer() {
            let mainPlayer;

            can.$('video[data-player], object.vjs-tech', this.element).each(
                (i, el) => {
                    const $el = can.$(el);

                    if (/idpr/i.test(el.id)) {
                        return;
                    }

                    if (
                        can.$('#pipExpand', this.element).has(el).length === 0
                    ) {
                        mainPlayer = $el;
                        return false;
                    }
                },
            );

            return mainPlayer;
        },

        '.vjs-big-play-button click'() {
            this.updateActiveChannel();
        },
    },
});
